import Flickity from 'flickity';
import raf from 'raf';

export default class Reviews {
  constructor() {
    const $els = document.querySelectorAll('.js-reviews-carousel');
    $els.forEach($el => new Carousel($el));
  }
}

class Carousel {
  constructor($el) {
    this.$el = $el;

    this.carousel = new Flickity($el, {
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      contain: true,
      cellAlign: 'center',
      autoPlay: 4000
    });
  }
}